import styled, { css } from 'styled-components';

/** Mod and zone cells are set in the darker semibold of the Figma (Purple/700), the ID and reader name stay regular. */
export const Accent = styled.span(
  ({ theme: { palette } }) => css`
    font-weight: 600;
    color: ${palette.grey[900]};
  `,
);
